// removed by extract-text-webpack-plugin
module.exports = {"List":"List__List___3ZUij","Item":"List__Item___OJpTv","ActiveItem":"List__ActiveItem___1nYyr","Name":"List__Name___2XMyR","Image":"List__Image___3PL2T","Text":"List__Text___2A0jh","Label":"List__Label___3ZY3I"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Building/Main/Popup/List/List.scss
// module id = 1307
// module chunks = 0